import "./normalsocialmediacard.scss"
import React from "react";

export interface INormalSocialMediaCard {
    image: string
    name: string
    id: string
    follower: string
    places: string[]
    cardID: number
    activateSocialMedia: string
    setActivateSocialMedia: React.Dispatch<React.SetStateAction<string>>
}

const NormalSocialMediaCard = ({
                                   image,
                                   name,
                                   id,
                                   follower,
                                   places,
                                   cardID,
                                   activateSocialMedia,
                                   setActivateSocialMedia
                               }: INormalSocialMediaCard) => {
    return (
        <div onClick={() => {
            setActivateSocialMedia(`card${cardID}`);
        }}
             className={activateSocialMedia === `card${cardID}` ? "Normal-Social-Media-Card active" : "Normal-Social-Media-Card"}>
            <div className="Social-Media-Card-Header text-center">
                <img src={image} alt="" className="img-fluid mx-auto"/>
                <h6 className="Social-Media-Card-Header-Name">{name}</h6>
                <h6 className="Social-Media-Card-Header-ID">{id}</h6>
                <h6 className="Social-Media-Card-Header-Follower">{follower}</h6>
            </div>
            <div className="Social-Media-Card-Body">
                {
                    places.map((place, index) => {
                        return (
                            <span key={index} className="Social-Media-Card-Body-Text">{place}</span>
                        );
                    })
                }
            </div>
        </div>
    );
}

export default NormalSocialMediaCard;